/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-01 14:40:16
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-23 16:35:04
 */
import ColumnTypes from '@/utils/ColumnTypes';

const nickname = {
	key: 'nickname',
	label: '用户名称',
	type: ColumnTypes.TextCell,
	width: '150',
};
const mobile = {
	key: 'mobile',
	label: '手机号',
	type: ColumnTypes.TextCell,
	width: '180',
};
const deptName = {
	key: 'deptName',
	label: '部门',
	type: ColumnTypes.TextCell,
	width: '140',
};
const roleName = {
	key: 'roleName',
	label: '用户角色',
	type: () => import('./roleName.vue'),
	width: '140',
};
const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	width: '100',
	headerAlign: 'left',
	mode: 'vertical',
	fixed: 'right',
};
export default {
	nickname,
	mobile,
	deptName,
	roleName,
	operations,
};
